import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { PaymentInfoResponse, SubmitClaimRequest } from '@/api/payments';
import type { PaymentClaim } from '@/api/payments';

export function usePaymentInfo(enabled = true) {
  return useQuery({
    queryKey: ['payments', 'info'],
    queryFn: () => api.get<PaymentInfoResponse>('/api/payments/info'),
    enabled,
  });
}

export function useSubmitPaymentClaim() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: SubmitClaimRequest) => api.post<PaymentClaim>('/api/payments/claims', request),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['payments'] }),
  });
}
